import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { GlobalConstants } from '../global-constants';
import Swal from 'sweetalert2';
import { AuthService } from '../services/auth.service';

declare var $: any;

@Component({
  selector: 'app-myprofile',
  templateUrl: './myprofile.component.html',
  styleUrls: ['./myprofile.component.less']
})
export class MyprofileComponent implements OnInit {
  name:any;
  phone:any;
  email:any;
  address:any;
  hide = true;
  hide2 = true;

  savedMethods: any[] = [];
  defaultPm = '';
  customerId = '';
  pmLoading = true;
  pmError = '';

  constructor(private http: HttpClient, private authService: AuthService) { }

  ngOnInit(): void {
    this.customerId = this.authService.getCustomerId();
    $('.preloader').show();

    const headers = { 'Content-type': 'application/json' };
    this.http.post(GlobalConstants.apiURL + 'customerdetails', { customer_id: this.customerId }, { headers })
      .subscribe((Response: any) => {
        if (Response) {
          $('.preloader').fadeOut();
          this.name    = Response.customer.c_name;
          this.email   = Response.customer.c_email;
          this.phone   = Response.customer.c_mobile;
          this.address = Response.customer.c_address;
        }
      });

    this.http.get<any>(GlobalConstants.apiURL + 'customer_payment_methods', { headers })
      .subscribe({
        next: res => {
          this.pmLoading = false;
          if (res.success) {
            this.savedMethods = res.methods || [];
            this.defaultPm    = res.default_pm || '';
            this.pmError      = '';
          } else {
            this.savedMethods = [];
            this.pmError = res.error || 'Payment methods could not be loaded.';
          }
        },
        error: () => {
          this.pmLoading = false;
          this.savedMethods = [];
          this.pmError = 'Payment methods could not be loaded. Please try again.';
        }
      });
  }
  setDefaultPm(pmId: string): void {
    const headers = { 'Content-type': 'application/json' };
    this.http.post<any>(GlobalConstants.apiURL + 'set_default_pm', { pm_id: pmId, customer_id: this.customerId }, { headers })
      .subscribe({ next: res => {
        if (res.success) {
          this.defaultPm = pmId;
          this.savedMethods = this.savedMethods.map(m => ({ ...m, is_default: m.id === pmId }));
        }
      }});
  }

  deletePm(pmId: string): void {
    Swal.fire({
      title: 'Remove Payment Method',
      text: 'Are you sure you want to remove this payment method?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Remove',
      cancelButtonText: 'Cancel'
    }).then(result => {
      if (result.isConfirmed) {
        const headers = { 'Content-type': 'application/json' };
        this.http.post<any>(GlobalConstants.apiURL + 'delete_pm', { pm_id: pmId }, { headers })
          .subscribe({ next: res => {
            if (res.success) {
              this.savedMethods = this.savedMethods.filter(m => m.id !== pmId);
            }
          }});
      }
    });
  }

  updateAddress(newaddress:any){
    const headers = { 'Content-type': 'application/json'};
    const body = {
      customer_id: this.authService.getCustomerId(),
      address:newaddress,
    };
    this.http.post(GlobalConstants.apiURL+'addressupdate', body, { headers })
      .subscribe((Response: any) => {
        if (Response.status === "success") {
          window.location.reload();
          
          }
  
  
      });
  }
  changepassword(oldpassword:any,newpassword:any,confirmpassword:any){
    if(!oldpassword || oldpassword.length<3){
      $('#pwdupdt p').html('Please check password you entered.');
      $('#pwdupdt').show();
    }
    else if(newpassword<7){
      $('#pwdupdt p').html('Password is too short (atleast 6 characters)');
      $('#pwdupdt').show();
    }
    else if(newpassword != confirmpassword){
      $('#pwdupdt p').html('Please make sure your passwords match.');
      $('#pwdupdt').show();
    }
    else{
      $('#pwdupdt').hide();
      const headers = { 'Content-type': 'application/json'};
      const body = {
        c_id: this.authService.getCustomerId(),
        oldpass:oldpassword,
        newpass:confirmpassword,
      };
      this.http.post(GlobalConstants.apiURL+'changepassword', body, { headers })
        .subscribe((Response: any) => {
          if (Response.status === "success") {
              $('#pwdupdt').hide();
              Swal.fire({
                title: 'Success',
                text: "Your passwrod updated.",
                icon: 'success',
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload();
                }
              })
            }
          else{
            $('#pwdupdt p').html(Response.message);
            $('#pwdupdt').show();
          }
    
    
        });
    }
  }

}
